import { AddNewDeviceGridView, DeviceCardGridView } from "./components";
import Skeleton from "react-loading-skeleton";
import cn from "classnames";
import { devicesLoaded } from "../redux/devices-slice";
import sharedStyles from "../shared.module.scss";
import styles from "./DevicesGridView.module.scss";
import { useSelector } from "react-redux";

const SKELETONS_DEVICE_COUNT = 4;

export function DevicesGridView({ devices }) {
  const success = useSelector(devicesLoaded);

  const skeletons = Array(SKELETONS_DEVICE_COUNT)
    .fill()
    .map((_, idx) => <Skeleton key={idx} className={styles.skeleton} />);

  return (
    <div className={cn(styles.devicesGridView, sharedStyles.content)}>
      {success ? (
        <>
          {devices?.map((device) => (
            <DeviceCardGridView device={device} key={device.deviceId} />
          ))}
          <AddNewDeviceGridView />
        </>
      ) : (
        skeletons
      )}
    </div>
  );
}
